import React from 'react';
import formSchema from './schema';
// import { useIntl } from 'react-intl';
import BuildForm from '../../components/BuildForm/BuildForm';
import { renderField } from '../../utils/renderFields';
import styles from './BasicInfoForm.module.css';
import { get } from '../../utils/utils';

const BasicInfoContinuedForm = ({
  layoutSchema,
  spaceProfile,
  setSpaceProfile,
  saveProfile,
  errors,
  setErrors,
  isReadOnly,
  fieldSettings,
  setIsFormDirty,
  openSection,
  setOpenSection,
  spaceProfilePhotos,
  setSpaceProfilePhotos
}) => {
  // const intl = useIntl();
  // const t = (id) => intl.formatMessage({ id });

  // const form = useMemo(() => spaceProfile.basic_info, [spaceProfile.basic_info]);
  // updates the space profile object any time a field is changed
  const updateField = (field, { target: { type, value, checked } }, base, skipDirty, fullKey) => {
    let newErrors = errors && [...errors];
    newErrors = newErrors && newErrors.filter(error => error.key !== fullKey);
    setErrors(newErrors);
    if (!skipDirty) setIsFormDirty(true);
    const formObj = base || spaceProfile.basic_info;
    if (type === 'checkbox') {
      formObj[field] = checked;
    } else {
      formObj[field] = type === 'number' && value ? parseFloat(value) : value;
    }

    setSpaceProfile({ ...spaceProfile });
  }

  const generalInfo =
    <>
      <div className="d-flex flex-wrap w-100">
        <div className={`${styles.field} pr-5`}>
          {renderField[get(formSchema, `actual_sq_ft.type`, 'text')]('basic_info.actual_sq_ft', spaceProfile, formSchema, fieldSettings, updateField, saveProfile, isReadOnly, errors, setErrors, spaceProfilePhotos, setSpaceProfilePhotos)}
          {renderField[get(formSchema, `overall_actual_sq_ft.type`, 'text')]('basic_info.overall_actual_sq_ft', spaceProfile, formSchema, fieldSettings, updateField, saveProfile, isReadOnly, errors, setErrors, spaceProfilePhotos, setSpaceProfilePhotos)}

        </div>
      </div>
    </>

  return <BuildForm
    layoutSchema={layoutSchema}
    formSchema={formSchema}
    form={spaceProfile}
    setForm={setSpaceProfile}
    updateField={updateField}
    saveForm={saveProfile}
    errors={errors}
    setErrors={setErrors}
    isReadOnly={isReadOnly}
    fieldSettings={fieldSettings}
    setIsFormDirty={setIsFormDirty}
    setOpenSection={setOpenSection}
    openSection={openSection}
    embeddedContent={[{top: generalInfo}]}
    spaceProfilePhotos={spaceProfilePhotos}
    setSpaceProfilePhotos={setSpaceProfilePhotos}
  />
}

export default BasicInfoContinuedForm;